import { EntityVm } from "api/core/entity.vm";
import { IsNotEmpty, IsString } from "class-validator";

export class DeviceVm extends EntityVm {
    @IsString()
    @IsNotEmpty()
    name: string;

    @IsString()
    @IsNotEmpty()
    warehouseId: string;
}